/**
 * Font list aligned with Whiteboard TipTapEditor (Whiteboard/src/components/tiptapEditor/TipTapEditor.tsx).
 * Do not import Whiteboard here — single source in aiRecording only.
 */

export const VIDEO_EDITOR_FONT_FAMILIES: readonly string[] = [
  'Inter',
  'Comic Sans MS',
  'Serif',
  'Monospace',
  'Cursive',
  'Open Sans',
  'Roboto',
  'Lato',
  'Poppins',
  'Raleway',
  'Montserrat',
  'Oswald',
  'Source Sans Pro',
  'Nunito',
  'Playfair Display',
  'LoRa',
  'Alegreya',
  'PT Sans',
  'Ubuntu',
  'Fira Sans',
  'Rubik',
  'Work Sans',
  'Cormorant',
  'Muli',
  'Roboto Slab',
  'Impact',
] as const;

/** Fonts that load from Google Fonts (others use system / local stacks). */
const GOOGLE_FONT_SLUG: Partial<Record<string, string>> = {
  Inter: 'Inter',
  'Open Sans': 'Open+Sans',
  Roboto: 'Roboto',
  Lato: 'Lato',
  Poppins: 'Poppins',
  Raleway: 'Raleway',
  Montserrat: 'Montserrat',
  Oswald: 'Oswald',
  'Source Sans Pro': 'Source+Sans+Pro',
  Nunito: 'Nunito',
  'Playfair Display': 'Playfair+Display',
  LoRa: 'Lora',
  Alegreya: 'Alegreya',
  'PT Sans': 'PT+Sans',
  Ubuntu: 'Ubuntu',
  'Fira Sans': 'Fira+Sans',
  Rubik: 'Rubik',
  'Work Sans': 'Work+Sans',
  Cormorant: 'Cormorant',
  Muli: 'Mulish',
  'Roboto Slab': 'Roboto+Slab',
};

/**
 * Injects a <link> to Google Fonts for the given family when applicable.
 * Idempotent per family (stable link id).
 */
export function loadGoogleFontIfNeeded(family: string): void {
  const slug = GOOGLE_FONT_SLUG[family];
  if (!slug || typeof document === 'undefined') return;
  const id = `airec-ve-gfont-${slug.replace(/[^a-zA-Z0-9]/g, '')}`;
  if (document.getElementById(id)) return;
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.crossOrigin = 'anonymous';
  link.href =
    `https://fonts.googleapis.com/css2?family=${slug}` +
    ':ital,wght@0,400;0,700;1,400;1,700&display=swap';
  document.head.appendChild(link);
}
